import Vue from 'vue'
import Emoji from '@pluzchat/emoji'

Vue.use(Emoji)
